import fetch from "../fetch";
import pickBy from "lodash/pickBy";

export default ({ params = {} } = {}) =>
  fetch({ path: "/cmbs/offering-types", params: pickBy(params) });
